module.exports = require('../impls/repeat-times/repeat-times.js').repeatTimes;